var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDuratexHw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#F4F4F5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.69,32.82c4.93,0,10.18-2.08,10.18-9s-5.24-9-10.18-9H6.13v18ZM2.18,11h9.66C19.17,11,26,15,26,23.83S19.17,36.67,11.84,36.67H2.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.65,25.7V11h4V25.65c0,4.88,3,7.79,7.74,7.79s7.74-2.91,7.74-7.79V11h4V25.7c0,7.17-5.09,11.54-11.74,11.54S30.66,32.88,30.66,25.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M60.74,11h3.95v4.94c1.67-3.17,4.78-5,9.09-5v4c-4.62-.1-9.09,2.5-9.09,9.51V36.66H60.74Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M99.1,23.83a9.23,9.23,0,0,0-8.95-9.51h-.57a9.51,9.51,0,1,0,9.52,9.51M76,23.83A13.38,13.38,0,0,1,89.22,10.42a12.19,12.19,0,0,1,9.93,4.68V11h3.95V36.67H99.15V32.56a12.19,12.19,0,0,1-9.93,4.68A13.37,13.37,0,0,1,76,23.83"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M114.27,18.48V28.77c0,4.26,2.7,5.4,7.85,4.21v3.63c-7.23,1.51-11.8-1.09-11.8-7.48V18.48Zm0-15.13V11h7.48v3.9H110.31V3.35Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M129.75,20.92h17.67c-1.09-4.31-4.57-6.55-8.78-6.55a9.28,9.28,0,0,0-8.89,6.55m22.09,3.79H129.39a9.17,9.17,0,0,0,9.41,8.58c4.36,0,7.17-2,8.42-4.78h4.31c-1.61,5.35-7,8.73-12.79,8.73a13.41,13.41,0,0,1,0-26.82h0a13,13,0,0,1,13.2,12.69v.14a7.91,7.91,0,0,1-.1,1.46"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M163.27,23.62,153.81,11h4.73l7.12,9.62L172.83,11h4.73l-9.45,12.63,9.71,13h-4.73l-7.43-10-7.43,10H153.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDuratexHw);
export default __webpack_public_path__ + "static/media/logo-duratex-hw.1b61f18e96256f0234fbe83decb3c142.svg";
export { ForwardRef as ReactComponent };